// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"ef5da305","488":"269365da","495":"cf4adf04","769":"c023d86d"}[chunkId] + ".chunk.js";
};